export default "__VITE_ASSET__DlVXrxB___"